module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "calendrier-mensuel",
    attrs: {
      "data-testid": "calendrier-mensuel-section"
    }
  }, [_c('NavigationMois', {
    attrs: {
      "current-month": _vm.currentMonth,
      "current-year": _vm.currentYear
    },
    on: {
      "update-month": _vm.updateMonth
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.isAbsencesLoaded),
      expression: "!isAbsencesLoaded"
    }],
    staticClass: "calendar-container",
    attrs: {
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.8)"
    }
  }, [_c('div', {
    staticClass: "calendar-weekdays"
  }, _vm._l((_vm.weekdaysShort), function(day) {
    return _c('div', {
      key: day,
      staticClass: "weekday-header",
      attrs: {
        "data-testid": 'calendrier-mensuel-jour-' + day
      }
    }, [_vm._v("\n                    " + _vm._s(day) + "\n                ")])
  })), _vm._v(" "), _vm._l((_vm.weekNumbers), function(weekNumber) {
    return [_c('div', {
      key: 'week-' + weekNumber,
      staticClass: "calendar-week"
    }, _vm._l((_vm.getWeekDays(weekNumber)), function(day, index) {
      return _c('div', {
        key: 'day-' + weekNumber + '-' + index,
        class: [
          'calendar-day',
          {
            'other-month': !day.isCurrentMonth
          },
          {
            'weekend': day.isWeekEndDay
          },
          {
            'nonWorkingDay': day.isNonWorkingDay
          },
          {
            'current-day': day.isCurrentDay
          }
        ],
        attrs: {
          "data-testid": 'calendrier-mensuel-day-' + weekNumber + '-' + index
        }
      }, [_c('div', {
        staticClass: "day-number"
      }, [_vm._v(_vm._s(day.day))])])
    })), _vm._v(" "), _c('div', {
      key: 'separator-' + weekNumber,
      staticClass: "calendar-separator"
    }, _vm._l((_vm.getAbsencesForWeek(weekNumber)), function(absence) {
      return _c('AbsencePlanningMensuel', {
        key: 'absence-' + weekNumber + '-' + absence.Id,
        attrs: {
          "data-testid": 'absence-planning-mensuel-' + weekNumber + '-' + absence.Id,
          "absence": absence,
          "week-days": _vm.getWeekDays(weekNumber),
          "week-number": weekNumber,
          "first-week-map": _vm.firstWeekMap
        }
      })
    }))]
  }), _vm._v(" "), _c('div', {
    staticClass: "calendrier-mensuel-legend"
  }, _vm._l((_vm.calendarLegends), function(legend) {
    return _c('div', {
      key: legend.libelle,
      staticClass: "legend"
    }, [_c('div', {
      staticClass: "legend-color",
      style: ({
        backgroundColor: legend.color
      })
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(legend.libelle))])])
  }))], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfc60ffc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsencesV2/calendrierMensuel/calendrierMensuel.vue.html
// module id = TGPP
// module chunks = 2